import PropTypes from "prop-types";
import { slugify } from "../../../utils";

const BlogFilter = ({ categories, activeFilter, onChange }) => {
    return (
        <div className="filter-menu">
            <ul className="menu-list">
                <li>
                    <button
                        className={activeFilter === "*" ? "active" : ""}
                        onClick={() => onChange("*")}
                    >
                        all
                    </button>
                </li>
                {categories?.map((cat, idx) => {
                    const slug = slugify(cat);
                    return (
                        <li key={idx}>
                            <button
                                className={
                                    activeFilter === slug ? "active" : ""
                                }
                                onClick={() => onChange(slug)}
                            >
                                {cat}
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

BlogFilter.propTypes = {
    categories: PropTypes.array,
    activeFilter: PropTypes.string,
    onChange: PropTypes.func,
};

export default BlogFilter;
